<template>
  <CModal
    v-if="modal"
    :show.sync="modal"
    :no-close-on-backdrop="true"
    :centered="true"
    :title="title"
    size="lg"
    class="doctor-list-modal modal-width"
  >
    <div>
      <CRow>
        <CCol xs="12" lg="12">
          <div>
            <div class="row">
              <div class="form-group col-md-6 col-sm-6 mb-0">
                <label for>Medicine name</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter medicine name"
                  v-model="stock.name"
                  v-validate="'required'"
                  name="medicineName"
                />
                <span class="text-danger">{{ errors.first('medicineName') }}</span>
              </div>
              <div class="form-group col-md-6 col-sm-6">
                <label for>Cost</label>
                <input
                  type="text"
                  class="form-control"
                  placeholder="Enter cost"
                  v-model="stock.cost"
                  name="cost"
                  v-validate="'required|decimal'"
                />
                <span class="text-danger">{{ errors.first('cost') }}</span>
              </div>
            </div>

            <div class="form-group mb-0">
              <label for>Common Details</label>
              <div class="col-sm-12 p-0">
                <div class="checkbox">
                  <label class="mr-3">
                    <input type="checkbox" v-model="stock.has_manufacturer" class="mr-1" /> has manufacturer
                  </label>
                  <label class="mr-3">
                    <input type="checkbox" v-model="stock.has_model" class="mr-1" /> has model
                  </label>
                  <label class="mr-3">
                    <input type="checkbox" v-model="stock.has_expiry" class="mr-1" /> has expiry
                  </label>
                  <label class="mr-3">
                    <input type="checkbox" v-model="stock.has_batch" class="mr-1" /> has batch
                  </label>
                </div>
              </div>
            </div>
            <div>
              <v-select
                :items="items"
                :multiple="true"
                label="Specific details"
                v-model="stock.specific_details"
              ></v-select>
            </div>
            <div class="row">
              <div class="form-group col-md-6 col-sm-6 pb-0 pt-1 mb-3">
                <label for>Mode</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="stock.details.mode"
                  placeholder="Enter mode (E.g. dry syr)"
                />
              </div>

              <div class="form-group col-md-6 col-sm-6 pb-0 pt-1 mb-3">
                <label for>Size</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="stock.details.size"
                  placeholder="Enter size (E.g. 30ml)"
                />
              </div>

              <div class="form-group col-md-6 col-sm-6 pb-0 pt-1 mb-3">
                <label for>Power</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="stock.details.power"
                  placeholder="Enter power (E.g. 30ml)"
                />
              </div>

              <div class="form-group col-md-6 col-sm-6 pb-0 pt-1 mb-3">
                <label for>Dosage</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="stock.details.dosage"
                  placeholder="Enter dosage (E.g. 30ml)"
                />
              </div>

              <div class="form-group col-md-6 col-sm-6 pb-0 pt-1 mb-3">
                <label for>Quantity</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="stock.details.quantity"
                  placeholder="Enter quantity (E.g. 30ml)"
                />
              </div>

              <div class="form-group col-md-6 col-sm-6 pb-0 pt-1 mb-3">
                <label for>
                  Generic name
                  <code>"," sepreated</code>
                </label>
                <input
                  type="text"
                  class="form-control"
                  v-model="stock.details.generic_name"
                  placeholder="Enter generic name (E.g. cefixime 50 mg, lactobacillus 60 million cells)"
                />
              </div>

              <div class="form-group col-md-6 col-sm-6 pt-1 mb-1">
                <label for>Manufacturer</label>
                <input
                  type="text"
                  class="form-control"
                  v-model="stock.details.manufacturer"
                  placeholder="Enter manufacturer (E.g. Bestochem)"
                />
              </div>
            </div>
          </div>
        </CCol>
      </CRow>
    </div>
    <template #footer>
      <!-- <v-btn class="btn btn-danger mr-2" @click="modal = false">Close</v-btn> -->
      <v-btn class="btn btn-success" @click="submitMedicine()">Submit</v-btn>
    </template>
  </CModal>
</template>
<script>
import config from "@/config.js";
import Swal from "sweetalert2";
export default {
  $_veeValidate: {
    validator: "new"
  },
  data() {
    return {
      modal: false,
      title: "",
      items: [
        {
          text: "Medicine Type",
          value: "medicine_type"
        },
        {
          text: "Dosage",
          value: "dosage"
        },
        {
          text: "Medicine Category",
          value: "medicine_category"
        }
      ],
      stock: {
        stock_type: "medicine",
        name: "",
        cost: "",
        has_manufacturer: false,
        has_model: false,
        has_expiry: false,
        has_batch: false,
        specific_details: [],
        details: {
          mode: null,
          size: null,
          power: null,
          dosage: null,
          quantity: null,
          generic_name: null,
          manufacturer: null
        }
      }
    };
  },
  methods: {
    submitMedicine() {
      this.$validator.validate().then(valid => {
        if (valid) {
          let promise;
          if (this.stock.id) {
            let url = `${config.PHARMACY_URL}api/v1/admin/master-stock/${this.stock.id}`;
            promise = this.$http.put(url, this.stock);
          } else {
            let url = `${config.PHARMACY_URL}api/v1/admin/master-stock`;
            promise = this.$http.post(url, this.stock);
          }

          promise
            .then(res => {
              Swal.fire(res.body.message);
              this.modal = false;
              this.$emit("refreshList");
            })
            .catch(err => {
              Swal.fire(err.body.message);
            });
        }
      });
    },
    showModal(data) {
      this.title = data ? "Edit master medicine" : "Add master medicine";
      this.stock.doctor_medicine_id =
        data && data.doctor_medicine_id ? data.doctor_medicine_id : null;
      this.stock.id = data && data.id ? data.id : null;
      this.stock.name = data && data.name ? data.name : null;
      this.stock.cost = data && data.cost ? data.cost : null;
      this.stock.has_manufacturer =
        data && data.has_manufacturer ? data.has_manufacturer : false;
      this.stock.has_model = data && data.has_model ? data.has_model : false;
      this.stock.has_expiry = data && data.has_expiry ? data.has_expiry : true;
      this.stock.has_batch = data && data.has_batch ? data.has_batch : true;
      this.stock.specific_details =
        data && data.specific_details ? data.specific_details : null;
      this.stock.details.mode =
        data && data.details && data.details.mode ? data.details.mode : null;
      this.stock.details.size =
        data && data.details && data.details.size ? data.details.size : null;
      this.stock.details.power =
        data && data.details && data.details.power ? data.details.power : null;
      this.stock.details.dosage =
        data && data.details && data.details.dosage
          ? data.details.dosage
          : null;
      this.stock.details.quantity =
        data && data.details && data.details.quantity
          ? data.details.quantity
          : null;
      this.stock.details.generic_name =
        data && data.details && data.details.generic_name
          ? data.details.generic_name
          : null;
      this.stock.details.manufacturer =
        data && data.details && data.details.manufacturer
          ? data.details.manufacturer
          : null;
      this.modal = true;
    }
  },
  created() {
    // if (this.$route.params.id) {
    //   this.getMedicine(this.$route.params.id);
    // }
  }
};
</script>